export enum TaskStatus {
  TODO = 1,
  INPROGRESS,
  BLOCKED,
  COMPLETED,
}

export const status_list = [
  {
    id: "1",
    value: "To Do",
  },
  {
    id: "2",
    value: "In Progress", 
  },
  {
    id: "3",
    value: "Blocked",
  },
  {
    id: "4",
    value: "Completed",
  },
];
